import React from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  LuCircleCheck,
  LuClipboardList,
  LuMessageSquarePlus,
} from "react-icons/lu";
import B2BHubHomeHeader from "../../components/B2BHubHomeHeader";
import HubHomeFooter from "../../components/hub/HubHomeFooter";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/styles/home.scss";
import "../../assets/styles/raise_support_ticket.scss";

function formatDateTime(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export default function FeedbackSubmittedSuccessPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state || {};

  if (!state.feedbackNumber) {
    return <Navigate to="/help-center/feedback" replace />;
  }

  return (
    <div className="raise-ticket-page">
      <B2BHubHomeHeader />
      <main className="raise-ticket-main">
        <section className="ticket-success-card">
          <div className="ticket-success-card__icon" aria-hidden>
            <LuCircleCheck />
          </div>
          <h1>Feedback submitted successfully</h1>
          <p>
            Thank you for sharing your thoughts. Our team will review your feedback. Suggestions and
            general comments may be closed after review; items needing investigation may be assigned
            for follow-up.
          </p>

          <dl className="ticket-success-meta">
            <div>
              <dt>Feedback ID</dt>
              <dd>{state.feedbackNumber}</dd>
            </div>
            <div>
              <dt>Subject</dt>
              <dd>{state.subject || "—"}</dd>
            </div>
            <div>
              <dt>Current Status</dt>
              <dd>
                <span className="ticket-success-status">{state.status || "New"}</span>
              </dd>
            </div>
            <div>
              <dt>Submission Date &amp; Time</dt>
              <dd>{formatDateTime(state.createdAt)}</dd>
            </div>
          </dl>

          <div className="ticket-success-actions">
            <Link
              to={
                state.feedbackId
                  ? `/dashboard/help-center/my-feedback/${state.feedbackId}`
                  : "/dashboard/help-center/my-feedback"
              }
              className="raise-ticket-btn raise-ticket-btn--primary"
            >
              <LuClipboardList aria-hidden /> View My Feedback
            </Link>
            <button
              type="button"
              className="raise-ticket-btn raise-ticket-btn--ghost"
              onClick={() => navigate("/help-center/feedback")}
            >
              <LuMessageSquarePlus aria-hidden /> Submit Another Feedback
            </button>
          </div>
        </section>
      </main>
      <HubHomeFooter />
    </div>
  );
}
